import { Type } from '@angular/core';
import { UITableBaseColumn } from '../components';
import { ITableColumnCellConfigType } from './table-column-cell-config.model';

export type TablePaginationType = 'none' | 'client-side' | 'server-side';

export enum TableColumnType {
  Checkbox = 'checkbox',
  Order = 'order',
  Basic = 'basic',
  Custom = 'custom',
  Actions = 'actions',
}

export type ITableColumnConfigType =
  | ITableOrderColumn
  | ITableBasicColumn
  | ITableCustomColumn
  | ITableActionsColumn;

export type TableColumnAlignType = 'left' | 'center' | 'right';
export type TableRowSelectionType = 'single' | 'multiple' | 'none';

export interface ITableConfig {
  columns: ITableColumnConfigType[];
  paginationType?: TablePaginationType;
  emptyDataText?: string;
  rowSelection?: {
    type: TableRowSelectionType;
    selectByField: string;
  };
  trackBy?: (rowData: unknown) => string | number;
}

export interface ITableColumnConfig {
  type: TableColumnType;
  name?: ITableColumnCellConfigType | string;
  subName?: ITableColumnCellConfigType | string;
  title?: string;
  width?: string;
  align?: TableColumnAlignType;
  sortable?: boolean;
  isHidden?: boolean;
}

export interface ITableOrderColumn extends ITableColumnConfig {
  type: TableColumnType.Order;
}
export interface ITableBasicColumn extends ITableColumnConfig {
  type: TableColumnType.Basic;
  name?: ITableColumnCellConfigType;
  subName?: ITableColumnCellConfigType;
  downloadFieldName?: string;
}

export interface ITableCustomColumn extends ITableColumnConfig {
  type: TableColumnType.Custom;
  name?: string;
  subName?: string;
  component: string | Promise<Type<UITableBaseColumn>>;
  valueField?: string; // имя поля из строки, которое передается в компонент
}

export interface ITableActionsColumn extends ITableColumnConfig {
  type: TableColumnType.Actions;
  buttons?: ITableActionsColumnDetails[];
}

export interface ITableActionsColumnDetails {
  type: TableActionsColumnType;
  permissions?: number[]; // use Enum
  title?: string;
  icon?: string;
  color?: string;
  hideCondition?: (rowData: any) => boolean;
}

export type TableActionsColumnType = 'edit' | 'delete' | 'details' | string | (string & object);

export interface ITableActionsColumnReturnData<T = any> {
  type: TableActionsColumnType;
  rowData: T;
}
